import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ILocalAsset } from 'src/app/models/assets/assets.model';

import { AssetCollection, AssetLocation, AssetScope } from '../models/asset-browser.model';

@Component({
    selector: 'app-asset-browser-sidebar',
    templateUrl: './asset-browser-sidebar.component.html',
    styleUrls: ['./asset-browser-sidebar.component.scss'],
})
export class AssetBrowserSidebarComponent {
    @Input({ required: true }) location!: AssetLocation;
    @Input() folders: ILocalAsset[] = [];
    @Input() hosted = false;
    @Input() mobileOpen = false;

    @Output() navigate = new EventEmitter<AssetLocation>();
    @Output() close = new EventEmitter<void>();
    @Output() moveToFolder = new EventEmitter<string>();
    @Output() addToProject = new EventEmitter<void>();
    @Output() renameFolder = new EventEmitter<ILocalAsset>();
    @Output() deleteFolder = new EventEmitter<ILocalAsset>();

    public go(scope: AssetScope, collection: AssetCollection = 'all', folderPath: string[] = []): void {
        this.navigate.emit({ ...this.location, scope, collection, folderPath, projectId: this.location.projectId });
        this.close.emit();
    }

    public isActive(scope: AssetScope, collection: AssetCollection = 'all', folderPath: string[] = []): boolean {
        return (
            this.location.scope === scope &&
            this.location.collection === collection &&
            this.location.folderPath.length === folderPath.length &&
            this.location.folderPath.every((folder, index) => folder === folderPath[index])
        );
    }

    public dropOnFolder(event: DragEvent, folderName: string): void {
        event.preventDefault();
        this.moveToFolder.emit(folderName);
    }

    public dropOnRoot(event: DragEvent): void {
        event.preventDefault();
        this.moveToFolder.emit('/');
    }

    public dropOnProject(event: DragEvent): void {
        event.preventDefault();
        this.addToProject.emit();
    }
}
